export default __webpack_public_path__ + "static/char-38-f43af8eeaae022588000b825a0d13d8a.webp";